import React from 'react';
import { Layout, Typography, Space } from "antd";
import "../../styles/fluidDesign.css";

const { Footer } = Layout;
const { Text, Link } = Typography;

const Footerdiv = () => {
    return (
        <Footer className="fluid-footer">
            <div className="fluid-footer-content">
                <Space split={<span className="fluid-footer-divider">•</span>}>
                    <Text className="fluid-footer-text">
                        AgroLand Management System
                    </Text>
                    <Text className="fluid-footer-text">
                        Developed by{' '}
                        <Link
                            href="https://dsoftmedia.com"
                            target="_blank"
                            className="fluid-footer-link"
                        >
                            DSM IT PVT LTD
                        </Link>
                    </Text>
                </Space>
            </div>
        </Footer>
    );
};

export default Footerdiv;